module.exports = __webpack_public_path__ + "static/img/twin-highway-2.73109db4.png";